export const emailRegex =
  /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;

export const INPUT_BORDER_COLOR = "#dee2e6";
export const INPUT_TEXT_COLOR = "#32325d"; //Changed the color of text match other input text color
export const LIGHT_BG_COLOR = "#f5f5f5";
//<--------- Constants for CreateCustomPlan Component ------>

// Plan Duration List
export const PLAN_DURATION_LIST = [
  { label: "1 Month", value: 1 },
  { label: "3 Month", value: 3 },
  { label: "6 Month", value: 6 },
  { label: "12 Month", value: 12 },
];

//currency constant
export const CURRENCY = {
  INR: "INR",
  USD: "USD",
};

//currency symbol
export const CURRENCY_SYMBOL = {
  INR: "₹",
  USD: "$",
};

//list of currency
export const CURRENCY_LIST = [
  { label: "$-USD", value: "USD" },
  { label: "₹-INR", value: "INR" },
];

export const PLAN_MULTIPLIER = [
  { label: "plan x 1", value: 1 },
  { label: "plan x 2", value: 2 },
  { label: "plan x 3", value: 3 },
  { label: "plan x 4", value: 4 },
  { label: "plan x 5", value: 5 },
];

//for customizing the appearance of the React Select to match other input fields
export const CUSTOM_STYLES = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.selectProps.className?.includes("is-invalid")
      ? "red"
      : INPUT_BORDER_COLOR,
    height: "2.8rem",
    fontSize: "0.85rem",
  }),
  //for the add new option styling in email config list drop down
  option: (provided, state) => ({
    ...provided,
    color: state.data.isSpecial ? "blue" : provided.color,
    fontWeight: state.data.isSpecial ? "500" : provided.fontWeight,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: INPUT_TEXT_COLOR,
  }),
  menuList: (provided) => ({
    ...provided,
    fontSize: "0.8rem",
  }),
};

//<------------ End of createCustomPlan constants----------->

export const DATE_RANGE_OPTIONS = [
  { label: "Last 7 Days", value: "7" },
  { label: "Last 30 Days", value: "30" },
  { label: "Last 90 Days", value: "90" },
  { label: "Custom Date", value: "custom" },
];
